/**
 * Custom hook for request tag logic
 * Centralizes tag computation, labeling, and coloring
 */

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { REQUEST_TAGS, TAG_COLORS } from '../../../constants/request.constant';
import { computeRequestTag } from '../../../components/common/Reviews_Cards/tabUtils';

export const useRequestTags = () => {
  const { t } = useTranslation();

  const getRequestTag = useCallback((request, status) => {
    return request.tag || computeRequestTag(request, status);
  }, []);

  const getTagLabel = useCallback(
    (tag) => {
      if (!tag) return null;

      const labels = {
        [REQUEST_TAGS.NEW]: t('New'),
        [REQUEST_TAGS.SENT_BACK]: t('Sent Back'),
        [REQUEST_TAGS.RESUBMITTED]: t('Resubmitted'),
        [REQUEST_TAGS.UNDER_SUBMISSION]: t('Under Submission'),
        [REQUEST_TAGS.UNDER_REVIEW]: t('Under Review'),
      };

      return labels[tag] || tag;
    },
    [t]
  );

  const getTagColor = useCallback((tag) => {
    return tag ? TAG_COLORS[tag] : null;
  }, []);

  const getTagInfo = useCallback(
    (request, status) => {
      const tag = getRequestTag(request, status);
      return {
        tag,
        label: getTagLabel(tag),
        color: getTagColor(tag),
      };
    },
    [getRequestTag, getTagLabel, getTagColor]
  );

  return { getRequestTag, getTagLabel, getTagColor, getTagInfo };
};
